var _path, _path2, _path3, _path4, _path5, _polygon, _rect, _rect2, _rect3, _circle, _path6, _path7, _path8, _path9, _path10, _polygon2, _rect4, _rect5, _rect6, _circle2, _path11, _path12, _path13, _path14, _polygon3, _path15, _polygon4, _path16, _path17, _path18, _circle3, _path19, _path20, _path21, _path22, _path23, _path24, _polygon5, _rect7, _rect8, _rect9, _circle4, _path25, _path26, _path27, _circle5, _circle6, _path28, _circle7, _circle8, _path29, _path30, _rect10, _polygon6, _polygon7, _path31, _path32, _path33, _circle9, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _polygon8, _rect11, _rect12, _rect13, _circle10, _path42, _circle11, _circle12, _path43, _path44;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawDeliveries(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 638.67004,
    height: 460.38915,
    viewBox: "0 0 638.67004 460.38915",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M595.5684,678.24928H571.03448V489.42585h19.95273a3.65579,3.65579,0,0,1,3.65575,3.63752Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M573.32745,679.249H309.86261V544.77436H573.32745Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M469.48272,678.749H310.36261V545.27436H572.82745v30.12989A103.4619,103.4619,0,0,1,469.48272,678.749Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M591.57256,494.78943h0a3.65594,3.65594,0,0,0-.30626.78975l-9.08489,35.01823-9.85428,18.66275H310.86267V544.6119l14.886-14.01449,17.3653-33.21595a14.823,14.823,0,0,1,2.97831-3.92783l0,0a14.82331,14.82331,0,0,1,10.1581-4.02777H588.34017A3.6558,3.6558,0,0,1,591.57256,494.78943Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M573.32745,679.249H309.86261V544.77436H573.32745Zm-261.46484-2H571.32745V546.77436H311.86261Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#e6e6e6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "306.37 292.898 301.516 310.792 45.084 310.792 53.37 295.898 306.37 292.898",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.91317,
    y: 395.43549,
    width: 41.99886,
    height: 2.32413,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.91317,
    y: 403.56994,
    width: 41.99886,
    height: 2.32413,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.91317,
    y: 411.70439,
    width: 41.99886,
    height: 2.32413,
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.18207,
    cy: 354.43911,
    r: 15.10683,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M501.42093,520.449h-12.8301V421.70308h10.43435a1.91181,1.91181,0,0,1,1.91179,1.90225Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M489.78994,520.97174H352.01008v-70.324H489.78994Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M435.484,520.71027H352.27156v-69.801H489.52847v15.75653A54.10577,54.10577,0,0,1,435.484,520.71027Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#f2f2f2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M499.33129,424.508h0a1.91231,1.91231,0,0,0-.16016.413l-4.751,18.31291-5.15334,9.75975H352.53307v-2.43082l7.7847-7.32893,9.08125-17.3704a7.75164,7.75164,0,0,1,1.55752-2.05407v0a7.75192,7.75192,0,0,1,5.31221-2.10633H497.6409A1.91181,1.91181,0,0,1,499.33129,424.508Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M489.78994,520.97174H352.01008v-70.324H489.78994ZM353.056,519.92584H488.744V451.69368H353.056Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#e6e6e6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "216.293 214.071 213.755 223.428 79.653 223.428 83.986 215.639 216.293 214.071",
    fill: "#ccc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 76.42588,
    y: 267.69308,
    width: 21.96345,
    height: 1.21541,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76.42588,
    y: 271.94702,
    width: 21.96345,
    height: 1.21541,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76.42588,
    y: 276.20096,
    width: 21.96345,
    height: 1.21541,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.93376,
    cy: 246.25388,
    r: 7.90017,
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M879.54264,679.18061l-.07962-.42641a50.10389,50.10389,0,0,1,10.60466-40.7702,48.61337,48.61337,0,0,1,8.93259-8.30057l.31587-.22807.13824.364c1.64845,4.34628,3.72914,8.699,4.67731,10.62567l.6399-14.38221.36516-.19366a9.50231,9.50231,0,0,1,10.59241,1.09313,9.66513,9.66513,0,0,1,3.19161,10.34917c-.49728,1.68986-.96685,3.44272-1.42125,5.13784-1.56066,5.825-3.1744,11.84829-6.30184,16.92021a30.28516,30.28516,0,0,1-22.04055,13.92489Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#f2f2f2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M919.335,679.00457a1.18646,1.18646,0,0,1-1.19006,1.19H281.855a1.19,1.19,0,1,1,0-2.38h636.29A1.18651,1.18651,0,0,1,919.335,679.00457Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M775.00977,374.52959l-18.21283-2.60868c-6.15969,10.29987-8.34862,37.71487-8.34862,37.71487l-17.82409,42.36453a8.12291,8.12291,0,1,0,12.66329,6.10094l29.26533-49.31057Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#ffb8b8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M772.11086,323.96684l0,0A19.41185,19.41185,0,0,1,787.446,349.60854l-3.865,10.95476s-2.10383,32.98485-10.12737,42.29567l-24.62045-2.2287s4.50141-16.64134,1.04556-24.693c-2.11644-4.931-1.99888-21.96205.08649-35.81645A19.36217,19.36217,0,0,1,772.11086,323.96684Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#e6e6e6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "551.636 446.418 540.665 446.417 535.446 404.1 551.638 404.101 551.636 446.418",
    fill: "#ffb6b6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M832.68713,677.66825l-33.737-.00127v-.42666a13.13211,13.13211,0,0,1,13.13138-13.13118h.00082l6.16249-4.67519,11.49786,4.67591,2.945.0001Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "503.939 393.973 493.805 398.174 472.773 361.085 487.731 354.883 503.939 393.973",
    fill: "#ffb6b6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M789.34549,624.2018l-31.16392,12.9227-.16344-.39411a13.13211,13.13211,0,0,1,7.09942-17.15982l.00075-.00031,3.90144-6.67926,12.412-.08536,2.7204-1.12808Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M844.84465,425.50032l-77.85831,8.13445-10.41481,35.07768L720.50378,526.675l39.8236,73.16741,14.02471-12.58808L760.89,528.17072l40.18115-43.3786,7.619-3.16149h0l6.04814,160.96767,22.37009.3674,9.78924-177.61794C851.60127,449.657,850.18543,436.70143,844.84465,425.50032Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M816.29934,314.45305l-12.77947-14.38961-20.1931,2.24368L770.39851,320.4l0,0a27.60081,27.60081,0,0,0-21.011,31.61524c5.01694,28.88867,22.06647,56.90722,16.43678,71.161-8.54573,21.63685-9.06715,30.46133,11.38917,27.42786s88.98913-10.02662,75.70216-23.3136-16.20541-35.49-16.20541-35.49l-.53282-50.79683a22.57643,22.57643,0,0,0-19.878-26.55058Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#e6e6e6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 510.66099,
    cy: 54.16034,
    r: 22.41544,
    fill: "#ffb8b8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M818.94518,272.63473a38.98092,38.98092,0,0,1-5.33133,12.77307,8.69446,8.69446,0,0,1-2.908,3.30177,3.17846,3.17846,0,0,1-4.03891-.50487l-.54529-.44428a11.5684,11.5684,0,0,0,2.82729-2.45363,3.93949,3.93949,0,0,0,.75729-3.52394,2.42571,2.42571,0,0,0-2.9686-1.58527c-1.31269.515-2.11036,2.41326-3.48357,2.12046-1.11074-.24239-1.343-1.70644-1.343-2.85755.04036-6.018-2.86766-14.57035-5.11933-14.30781a18.15643,18.15643,0,0,1-6.71465-.89867,17.592,17.592,0,0,0-6.72481-.85831c-.16153.02022-.32312.05054-.49476.0808a14.8906,14.8906,0,0,0-1.49438-3.2614,17.42314,17.42314,0,0,1-.18174,3.69557,34.56308,34.56308,0,0,1-5.59393,1.767c-2.08.29286-6.65406,6.51276-6.86613,5.87662a14.891,14.891,0,0,0-1.49438-3.2614,17.42323,17.42323,0,0,1-.18174,3.69558c-.01011.05047-.01011.0909-.02021.14138-1.00973-1.343-1.62565-2.97871-1.28238-1.72666-3.38256-7.65369-2.06993-13.1365,3.25136-19.58867a10.23212,10.23212,0,0,1,3.98837-3.20088,5.0296,5.0296,0,0,1,4.90732.48471,16.51044,16.51044,0,0,1,16.37774-3.49368c5.5434,1.92862,9.81458,3.05951,10.66272,8.87555,4.5842-.73715,9.29961,1.868,11.82393,5.75539C819.2683,263.13322,819.78327,268.08085,818.94518,272.63473Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M800.76819,458.81542h-7.43972V401.55625H799.379a1.1086,1.1086,0,0,1,1.10858,1.103Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M794.0238,459.11857H714.13023V418.34024H794.0238Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M762.53373,458.967H714.28185V418.49186h79.59033v9.13664A31.374,31.374,0,0,1,762.53373,458.967Z",
    transform: "translate(-280.66498 -219.80543)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M799.55648,403.18271h0a1.10851,1.10851,0,0,0-.09287.23949l-2.75492,10.619-2.98823,5.65933h-79.287V418.291l4.51407-4.24978,5.26588-10.07247a4.49533,4.49533,0,0,1,.90315-1.19108h0a4.49508,4.49508,0,0,1,3.08037-1.22139h70.37932A1.10859,1.10859,0,0,1,799.55648,403.18271Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M794.0238,459.11857H714.13023V418.34024H794.0238Zm-79.28709-.60648h78.68061V418.94672H714.73671Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "517.515 188.809 516.044 194.236 438.283 194.236 440.795 189.719 517.515 188.809"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 436.41141,
    y: 219.90322,
    width: 12.73581,
    height: 0.70477,
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 436.41141,
    y: 222.36993,
    width: 12.73581,
    height: 0.70477,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 436.41141,
    y: 224.83663,
    width: 12.73581,
    height: 0.70477,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 441.34482,
    cy: 207.4714,
    r: 4.58102,
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M831.84962,369.29434l-18.21283-2.60868c-6.15969,10.29988-8.34862,37.71487-8.34862,37.71487l-17.82408,42.36454a8.12291,8.12291,0,1,0,12.66328,6.10093l29.26533-49.31057Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#ffb8b8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M821.97833,318.73159l0,0a19.41186,19.41186,0,0,1,15.33508,25.64169l-3.865,10.95476s4.86855,32.98485-3.155,42.29567l-24.62045-2.2287s4.50141-16.64134,1.04556-24.693c-2.11644-4.931-1.99888-21.962.08649-35.81645C808.39746,324.30653,811.40617,317.0943,821.97833,318.73159Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#e6e6e6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M667.32642,264.15532A37.49249,37.49249,0,0,0,650.508,314.43965c9.24135,18.52991,42.63612,50.13257,69.28035,54.90755-11.46111-34.8,4.47477-70.17261-2.17758-88.37344C710.50248,261.52555,685.85635,254.914,667.32642,264.15532Z",
    transform: "translate(-280.66498 -219.80543)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "ae913700-e609-4a21-8232-fca89ee691a9",
    "data-name": "b262ea8c-1946-46c9-a449-3a1996c39394",
    cx: 399.15177,
    cy: 76.1926,
    r: 12.22754,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "e5607a81-7f0e-4105-ad7c-335322d1da37",
    "data-name": "bcc29a3a-8123-4529-80aa-6f70df2823cf",
    cx: 438.88838,
    cy: 161.15901,
    r: 8.00877
  })), /*#__PURE__*/React.createElement("path", {
    d: "M683.54331,283.14452a12.22731,12.22731,0,1,1,.82829,24.44058,12.22575,12.22575,0,0,0-4.68555-23.67726A12.22754,12.22754,0,0,1,683.54331,283.14452Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.67242,280.98089c6.65234,18.2008-9.28354,53.57339,2.17758,88.37343a51.86337,51.86337,0,0,1-7.41132-1.94c-9.33818-33.64086,5.318-67.25593-1.1093-84.8412C705.57675,266.834,688.338,259.50389,672.15031,262.178,689.91682,256.11879,711.15837,263.15847,717.67242,280.98089Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M342.32528,449.84605a34.74075,34.74075,0,0,0-35.56468,33.89677c-.46057,19.18124,13.19657,59.536,32.95,74.99262,5.69285-33.469,34.07295-55.5349,36.51141-73.32472C378.82762,466.40169,361.50653,450.30663,342.32528,449.84605Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#d1d3d4"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "bacd35f3-e339-4cac-822d-9d99fa991c5b",
    "data-name": "b262ea8c-1946-46c9-a449-3a1996c39394",
    cx: 58.09191,
    cy: 261.53342,
    r: 11.3301,
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "b2bbbf75-ebb5-482c-96b6-874581e74278",
    "data-name": "bcc29a3a-8123-4529-80aa-6f70df2823cf",
    cx: 53.8191,
    cy: 348.34314,
    r: 7.42097,
    fill: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.3789,472.42618a11.32988,11.32988,0,1,1-9.91245,20.37666,11.32844,11.32844,0,0,0,6.42245-21.42294A11.33006,11.33006,0,0,1,347.3789,472.42618Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.26947,485.44328c-2.43846,17.7898-30.81856,39.85575-36.51141,73.32471a48.05645,48.05645,0,0,1-5.22948-4.80049c6.92932-31.59963,33.49973-52.78063,35.85576-69.96877,2.10863-15.38373-8.83418-28.8574-23.25128-33.68185C364.31012,453.053,378.65723,468.02332,376.26947,485.44328Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M474.12669,302.22021a9.9594,9.9594,0,0,0-9.3019,10.317,9.55491,9.55491,0,0,0,.215,1.56481L435.6421,332.6224l16.25262,7.18813,25.42484-18.6893a9.93179,9.93179,0,0,0,7.02221-9.8848,9.50467,9.50467,0,0,0-9.95453-9.03246Q474.25686,302.2103,474.12669,302.22021Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#ffb6b6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M445.77821,324.20458l7.28585,15.03278-28.80763,18.5379a14.33039,14.33039,0,0,1-13.93045.93324h0a13.73069,13.73069,0,0,1-7.61525-14.64528l9.34751-53.365a14.80471,14.80471,0,0,1,16.25423-12.25855h0a14.04056,14.04056,0,0,1,12.43121,15.48357q-.02376.21722-.05425.43361a14.40418,14.40418,0,0,1-.29435,1.52357l-10.20455,37.95219Z",
    transform: "translate(-280.66498 -219.80543)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 125.96246,
    y: 127.70355,
    width: 41.1982,
    height: 41.1982,
    fill: "#ffb8b8"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "264.862 249.035 280.596 243.742 289.358 286.57 278.696 290.156 264.862 249.035",
    fill: "#ffb6b6"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.195 245.744 253.802 240.086 263.558 282.698 252.983 286.531 238.195 245.744",
    fill: "#ffb6b6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M408.10519,399.47017c-8.25739,55.04925,101.70446,22.50321,101.70446,22.50321l34.47742,47.56177,20.18473-3.66995s-9.08242-28.55253-25.30255-66.829C531.966,382.0379,450.173,386.19137,450.173,386.19137L448.47464,372.863l-46.79186-.91749Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M487.53569,425.66372l25.42737-15.8363c18.61478,37.17078,24.10184,53.26867,24.10184,53.26867l-17.59816,4.949Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M431.64063,280.5619l-8.29235-10.65911-11.82887-.51291-1.18061,10.02505-5.86117,2.7027a157.19212,157.19212,0,0,0-2.64779,68.102l0,0h0a6.06386,6.06386,0,0,1,1.72487,5.89024l-.38,1.51485.03516.05549a8.87365,8.87365,0,0,1,1.17807,6.62468v0l-2.799,4.97363a14.12449,14.12449,0,0,0,7.5182,20.20117c17.20545,6.23649,33.33421,8.55945,45.26616-8.94089l3.7519-60.9858Z",
    transform: "translate(-280.66498 -219.80543)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.28868,
    cy: 31.05715,
    r: 21.87086,
    fill: "#ffb8b8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M411.97427,224.49757c-9.26044.17791-16.60519,8.76764-16.405,19.18569-6.85289,7.15059-8.513,42.32156-2.78695,51.678,10.47464,1.21592,16.84592-24.69873,26.0319-20.95249l1.21029-5.65555,2.74309,7.36493q3.50171,1.61433,6.9506,3.544c1.65225-7.5789,1.24261-14.94579-3.19839-21.36252-3.94535-5.70059,5.65593-12.46829,12.52235-11.51175h0l-.10059-5.2357,1.7247,5.20449c2.67653,1.96682,5.63736,1.25477,8.67352-.16663v0C454.26314,221.00186,416.14513,214.00431,411.97427,224.49757Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#2f2e41"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M554.51508,517.20544l7.01-.91569.38671-6.78174,4.0692,6.19968,18.59227-2.42864a4.21485,4.21485,0,0,0,1.37962-7.92883l-16.18665-8.31454-.874-6.69088-15.49489,2.972Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#2f2e41"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M536.00006,517.26649l6.35944-3.088-1.78034-6.5553,5.82274,4.59241,16.86689-8.19016a4.21484,4.21484,0,0,0-1.20168-7.95773l-17.9864-2.762-2.94742-6.07-13.75682,7.72494Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#2f2e41"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M439.99768,371.42158h7.7981V311.40407h-6.342a1.162,1.162,0,0,0-1.162,1.15619Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#ccc"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M447.067,328.99659h83.74227v42.74274H447.067Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M447.22589,338.7323v-9.57678H530.6503v42.42489H480.074A32.88535,32.88535,0,0,1,447.22589,338.7323Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#f2f2f2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M441.26776,313.10889h0a1.16219,1.16219,0,0,1,.09734.251l2.88764,11.13054,3.13218,5.93195h83.10644V328.945l-4.73153-4.4545-5.51956-10.55769a4.71164,4.71164,0,0,0-.94665-1.24846h0a4.71162,4.71162,0,0,0-3.22876-1.28023H442.29517A1.162,1.162,0,0,0,441.26776,313.10889Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#f2f2f2"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M447.067,328.99659h83.74227v42.74274H447.067Zm83.10657,42.107H447.70266V329.63229h82.47087Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#e6e6e6"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "162.045 98.997 163.588 104.685 245.095 104.685 242.461 99.951 162.045 98.997",
    fill: "#ccc"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 233.70683,
    y: 131.58895,
    width: 13.34933,
    height: 0.73872,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 233.70683,
    y: 134.17448,
    width: 13.34933,
    height: 0.73872,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 233.70683,
    y: 136.76002,
    width: 13.34933,
    height: 0.73872,
    fill: "#fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 241.8851,
    cy: 118.55826,
    r: 4.80171,
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M483.815,265.8107A21.2872,21.2872,0,0,1,505.607,286.58076c.28221,11.7532-8.08612,36.48034-20.19,45.95131-3.48826-20.50792-20.878-34.0287-22.37216-44.92931C461.44837,275.95508,472.06177,266.09293,483.815,265.8107Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#d1d3d4"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "fecde2e6-4a2c-4b09-ace7-bfa7eb0316c1",
    "data-name": "b262ea8c-1946-46c9-a449-3a1996c39394",
    cx: 205.33651,
    cy: 65.30232,
    r: 6.94245,
    fill: "#fff"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "ad96ff4a-d650-41fb-aeb3-38eefe479f45",
    "data-name": "bcc29a3a-8123-4529-80aa-6f70df2823cf",
    cx: 207.95465,
    cy: 118.49449,
    r: 4.54716,
    fill: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M480.7184,279.64656a6.94232,6.94232,0,1,0,6.0738,12.48568,6.94144,6.94144,0,0,1-3.93532-13.12679A6.9424,6.9424,0,0,0,480.7184,279.64656Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.01586,287.62271c1.49415,10.9006,18.8839,24.42139,22.37217,44.92931a29.44783,29.44783,0,0,0,3.20433-2.94147c-4.2459-19.3625-20.52678-32.341-21.97042-42.873-1.29205-9.4263,5.4131-17.68221,14.2471-20.63836C470.34389,267.77572,461.55277,276.94873,463.01586,287.62271Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#231f20",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M471.44764,323.54115a9.9594,9.9594,0,0,0-10.644,8.92582,9.55535,9.55535,0,0,0-.00432,1.5795l-31.684,14.26018,15.09742,9.37468,27.77308-14.97894a9.93178,9.93178,0,0,0,8.32641-8.81428,9.50469,9.50469,0,0,0-8.60429-10.32688Q471.57793,323.54941,471.44764,323.54115Z",
    transform: "translate(-280.66498 -219.80543)",
    fill: "#ffb6b6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M440.32181,341.37739,445.4503,357.276l-31.1021,14.35941a14.33039,14.33039,0,0,1-13.92512-1.00959h0a13.73068,13.73068,0,0,1-5.5085-15.56061l16.665-51.55076a14.80471,14.80471,0,0,1,17.79856-9.88349h0a14.04057,14.04057,0,0,1,10.16146,17.05933q-.05369.21182-.11392.42188a14.40435,14.40435,0,0,1-.503,1.468l-15.37418,36.16816Z",
    transform: "translate(-280.66498 -219.80543)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawDeliveries);
export default __webpack_public_path__ + "static/media/undraw_deliveries.38d810dd.svg";
export { ForwardRef as ReactComponent };